import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyTasksList = lazyWithRetry(() => import('./TaskList'));
export * from './TaskDetails';
